/* global SafariViewController */
import { App } from '@capacitor/app';
import waitFor from 'xAppLib/libs/waitFor'
import logger from 'xAppLib/libs/logger'
import { hashDeviceId } from 'xAppLib/libs/hash'
import { app_runtime } from './runts';
import { update_runtime } from './prep_env';
import firebase_auth from './xAppLib/providers/firebase_auth_ionic';
import { StatusBar, Style } from '@capacitor/status-bar';

export default function prep_ionic() {
	if (!app.settings.is_ionic) 
		return 
	
	
	const cleanup = []
	
	window.addEventListener('statusTap', () =>  document.getElementById('app').scrollTo(0,0) )

	App.addListener('appUrlOpen', async (event) => {

		const { 
			url,
			iosSourceApplication,
			iosOpenInPlace
		} = event

		console.log('App.appUrlOpen', {url, iosSourceApplication, iosOpenInPlace})

		logger.log_api('Deeplink', "appUrlOpen", "result", {url})

		if (url) {
			const location = new URL(url);

			app.runtime = app_runtime(window.__.config, location) 
			await update_runtime()

			const { pathname, search } = location
			if (pathname) {
				app.history.push(pathname)
			}
			if (search?.includes('oidc=onepass'))
				 firebase_auth.onepass_login(true)
			
			

		}


    });

	
	waitFor(window,'AppRate').then(AppRate=>{
		try {
			AppRate.setPreferences({
				displayAppName: 'InstantScripts',
				usesUntilPrompt: 3,
				promptAgainForEachNewVersion: false,
				reviewType: {
					ios: 'InAppReview',
					android: 'InAppReview'
				},
				showPromptForInAppReview:false,
				openStoreInApp: true,
				storeAppURL: {
					ios: '1456598384',
					android: 'market://details?id=au.com.instant',
				},
				customLocale: {
					title: "Would you like to help others by rating our app?",
					message: "It won’t take more than a minute and your opinion will help thousands of Australians make the right decisions!",
					cancelButtonLabel: "No, Thanks",
					laterButtonLabel: "Remind Me Later",
					rateButtonLabel: "Rate It Now",
					yesButtonLabel: "Yes",
					noButtonLabel: "Not really",
					appRatePromptTitle: 'Would you like to help others by reviewing our app?',
					feedbackPromptTitle: 'Mind giving us some feedback?',
				},
				callbacks: {
					handleNegativeFeedback: function(){
						window.open('mailto:contact+rating@instantscripts.com.au', '_system');
					},
					onRateDialogShow: function(callback){
						logger.usg_log('AppRate', "action", "RateDialogShow")
					},
					onButtonClicked: function(buttonIndex){
						logger.usg_log('AppRate', "action", "ButtonClicked", {val:buttonIndex})
					}
				},
				openUrl: function(url) {
					console.log("openUrl",url);
					let safariAvailable = false;
					if (window.SafariViewController) {
						SafariViewController.isAvailable(function(available) {
							safariAvailable = available;
						});
					}
					
					logger.usg_log('AppRate', "action", "openUrl", {val:url, safariAvailable})

			
					if (!safariAvailable) {
						window.open(url, '_blank', 'location=yes');
					} else {
						SafariViewController.show(
							{
								url: url,
								// barColor: "#0000ff", // on iOS 10+ you can change the background color as well
								// controlTintColor: "#00ffff", // on iOS 10+ you can override the default tintColor
								// tintColor: "#00ffff", // should be set to same value as controlTintColor and will be a fallback on older ios
							},
				
							function(result) {
								logger.usg_log('AppRate', "action", "handler", {val:result})

							},
				
							function(msg) {
								logger.usg_log('AppRate', "error", msg)
							}
						);
					}
				}
			});
			
			AppRate.promptForRating(false)
		} catch (e) {
			logger.report_error('ERROR Initialising AppRate', e.toString(), {...e});
		} 
	
	})

	if (window.Capacitor?.isNativePlatform()!==true) {
		// Hackety Hack time
		// This is to allow the old (cordova) app to still be able to load the latest app bundle from OTA
		// while the new native app is being deployed and not everyone has been updated to the latest.
		// On an old cordova native bundle, Capacitor.isNativePlatform() is false 
		// So we know a) this is native (is_ionic) and not capacitor, so must be old cordova. 
		// In this event, we can load the old cordova JS file on the fly. 
		// This kicks in the rest of the plugins dependencies
		var s=document.createElement('script');
		s.type='text/javascript';
		s.src='/compat/cordova.js'
		document.body.appendChild(s)
		logger.usg_log('prep_ionic', "loaded", "hackety-hack-cordova")
	} else {
		logger.usg_log('prep_ionic', "loaded", "normal")
	}

	if (window.Capacitor?.getPlatform()=='android')  {
		StatusBar.setStyle({style: Style.Dark});
		StatusBar.setOverlaysWebView({overlay: false});
		StatusBar.setBackgroundColor({color: '#0065f2ff'});
	}

	if (__KETCH_DISPLAY__) {
		waitFor(window,'ketch').then(() => {
			// Poll for device id as it's not immediately available
			const pollForDeviceId = async (resolve, attempts = 0) => {
				if (app && app.dvc && app.dvc.dvcid) {
					try {
						// Use one-way hash to prevent linking back to user PII
						const hashedDeviceId = await hashDeviceId(app.dvc.dvcid);
						window.ketch?.("setIdentities", {
							"device_id": hashedDeviceId,
						});
					} catch (e) {
						console.error("Error setting Ketch identities:", e);
					}
					resolve();
					// give up after 10 attempts
				} else if (attempts < 10) {
					setTimeout(() => pollForDeviceId(resolve, attempts + 1), 100);
				}
			};
			return new Promise((resolve) => pollForDeviceId(resolve, 0));
		})
	}
	
	return _=> {
		cleanup.map(fn=>fn.call(null))
	}
	
		
}
